module.exports = __webpack_public_path__ + "img/background_qr.8104d6b7.webp";